import { Review } from '../models/review';
import { JsEnv } from '../../../core/models/js_env';
import { TypedEvent } from '../../../core/typed_event';
import { ReviewButtonAnalyticsData } from '../../../core/models/analytics/review_button_analytics_data';

export class ReviewAction {
  static readonly WRITE_REVIEW_EVENT = new TypedEvent<ReviewButtonAnalyticsData>()
  private static state: Review;
  static init(env: JsEnv, containerClass: any) {
    this.state = new Review(env.PAGE);
    return new containerClass(this.state.getModel());
  }

  /// レビューを書くボタン　計測
  static reviewButton(button, index, array) {
    let buttonSize = array.length;
    let analyticsData: ReviewButtonAnalyticsData = {
      analyticsData: {
        reviewButtonIndex: buttonSize > 1 ? index + 1 : null
      },
      target: button,
      linkName: 'ReviewWrite',
    }
    this.WRITE_REVIEW_EVENT.trigger(analyticsData);
  }
}
